"use client";

// src/visually-hidden.ts
import * as VisuallyHiddenPrimitive from "@radix-ui/react-visually-hidden";
var VisuallyHidden = VisuallyHiddenPrimitive.Root;

export {
  VisuallyHidden
};
